<div class="p-px-24">
  <div class="d-flex justify-content-between">
    <h1 class="fs-20 fw-7">Ajouter une non-disponibilité</h1>
    <svg-icon
      (click)="onDialogClose()"
      src="/assets/icons/close-modal-primary.svg"
      class="cursor-pointer"
    ></svg-icon>
  </div>
  <span class="fs-16 fw-3">
    Nous ne vous afficherons pas les missions qui se déroulent pendant vos
    périodes d’indisponibilité.</span
  >
  <div
    class="d-flex align-items-center justify-content-between"
    [formGroup]="formGroup"
  >
    <div class="my-px-16 min-w-px-300">
      <mat-label
        >Date de début de la non-disponibilité
        <span class="required">*</span>
      </mat-label>
      <input
        class="form-control py-px-12"
        placeholder="Sélectionner"
        formControlName="start"
        [min]="toDay"
        type="date"
        [defaultValue]="formGroup.get('start')?.value"
      />
    </div>
    <div class="my-px-16 min-w-px-300">
      <mat-label
        >Date de fin de la non-disponibilité
        <span class="required">*</span>
      </mat-label>
      <input
        class="form-control py-px-12"
        placeholder="Sélectionner"
        type="date"
        [min]="formGroup.get('start')?.value || toDay"
        formControlName="end"
        [defaultValue]="formGroup.get('end')?.value"
      />
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <app-button
      text="Annuler"
      (click)="onDialogClose()"
      [stroked]="true"
      class="me-2"
    ></app-button>
    <app-button
      text="Ajouter l’indisponibilité"
      (click)="submitDialog()"
      [disabled]="!formGroup.valid"
    ></app-button>
  </div>
</div>
